<script setup>
  import { defineProps, defineModel, defineEmits } from 'vue'
  // ----------------------------
  // Props
  // ----------------------------
  const props = defineProps({
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: '選択してください',
    },
    required: {
      type: Boolean,
      default: false,
    },
  })

  // ----------------------------
  // v-model
  // ----------------------------
  const model = defineModel()
  // ----------------------------
  // emit
  // ----------------------------
  const emit = defineEmits(['childEmit'])
  // ----------------------------
  // 関数
  // ----------------------------
  function emitEvent() {
    emit('childEmit')
  } 

</script>

<template>
  <select
    v-model="model"
    :required="required"
    @change="emitEvent()"
  >
    <option value="">
      {{ props.placeholder }}
    </option>
    <option
      v-for="option in options"
      :key="option.id"
      :value="option.pk"
    >
      {{ option.name }}
    </option>
  </select>
</template>

<style></style>
